import styles from "./cooperation.module.css";
import DOMPurify from "dompurify";
const Cooperation = ({textData}) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text53"]),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text54"]),
          }}
        ></h5>
      </div>
      <video
        autoPlay
        loop
        playsInline
        muted
        preload="true"
        src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-10-1.mp4"
        poster="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-10-1-poster.jpg"
      ></video>
    </div>
  );
};

export default Cooperation;
